import { Capacitor } from '@capacitor/core';

/**
 * Custom-scheme deep link the magic-link email redirects to on device. Without
 * it, the link resolves to https://localhost inside Chrome and never reopens the
 * app, leaving the user stuck on "Vérifiez votre boîte mail". This scheme must be
 * registered as an Android intent-filter (see AndroidManifest.xml) and added to
 * the Supabase Auth → URL Configuration → Redirect URLs allowlist.
 */
export const NATIVE_AUTH_CALLBACK = 'fr.lafete.app://auth/callback';

function stripTrailingSlash(value: string) {
  return value.replace(/\/+$/, '');
}

export function getAuthCallbackUrl() {
  if (Capacitor.isNativePlatform()) {
    return NATIVE_AUTH_CALLBACK;
  }

  const browserOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  const fallbackOrigin = (import.meta.env.VITE_SITE_URL as string | undefined) ?? '';
  const origin = stripTrailingSlash(browserOrigin || fallbackOrigin);

  if (!origin) {
    throw new Error('Missing auth callback origin');
  }

  return `${origin}/auth/callback`;
}
